export const navigation = {
  support: {
    question: "Potrzebna pomoc?",
    whatsappCta: "Napisz do nas na WhatsApp",
  },
  alt: {
    whatsapp: "Ikona WhatsApp",
    logo: "Logo panelu",
  },
};
